<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  <div class="space-y-2 text-center">
    <h1 class="text-2xl font-semibold tracking-tight">Accedi al tuo account</h1>
    <p class="text-muted-foreground text-sm">
      Inserisci la tua email per accedere
    </p>
  </div>
  <div class="grid gap-6">
    <form
      [formGroup]="form"
      (ngSubmit)="signIn()"
      class="flex flex-col gap-y-2.5"
    >
      @if (errorMessage()) {
        <p class="text-destructive text-sm text-center">
          {{ errorMessage() }}
        </p>
      }

      <div class="space-y-2">
        <label hlmLabel> Email </label>
        <input
          hlmInput
          class="w-full"
          type="email"
          id="email"
          formControlName="email"
          placeholder="nome@esempio.com"
          autocomplete="off"
        />
      </div>

      <div class="space-y-2">
        <label hlmLabel> Password </label>
        <app-password-input
          class="w-full"
          formControlName="password"
          placeholder="Inserisci la password"
        />
      </div>

      <button hlmBtn [disabled]="isLoading()" class="mt-4 w-full">
        @if (isLoading()) {
          <hlm-spinner size="sm" class="mr-2" />
        }
        Accedi
      </button>

      <button
        hlmBtn
        variant="link"
        [disabled]="isLoading()"
        class="mt-4 w-full"
        (click)="onChangePasswordClick()"
        type="button"
      >
        Password dimenticata?
      </button>

      <button
        hlmBtn
        variant="link"
        [disabled]="true"
        class="hidden"
        (click)="onSignUpClick()"
        type="button"
      >
        Non hai un account? Registrati
      </button>
    </form>
  </div>
</div>
